module.exports = __webpack_public_path__ + "img/garden_square.0c17a8d1.svg";